import StartButton from './StartButton';
export default StartButton;
export * from './StartButton';
